import UltMeta, { Meta } from "./UltMeta/index";

// 日历排期状态
class ScheduleState extends UltMeta {
    TO_BE_GENERATED = new Meta(5, "待生成");
    TO_BE_INITIATED = new Meta(6, "待发起");
    TO_BE_CONFIRMED = new Meta(1, "待确认");
    CONFIRMED = new Meta(2, "已确认");
    PICKED_UP = new Meta(3, "已提货");
    CANCELED = new Meta(4, "已取消");
}

export const SCHEDULE_STATE = new ScheduleState();
